import HeroComponent from '../components/hero';


/* global ga */

export default class RecipesController {

  constructor(options) {
    this.options = options;
    console.log('RECIPES CONTROLLER');

    this.recipes__hero = new HeroComponent({
      elem          :'section.recipes__hero',
      parallaxCopy  : true,
    });

    this.recipes_tips = new HeroComponent({
      elem      :'section.recipes__tips',
    });

    this.recipes_products = new HeroComponent({
      elem      :'section.recipes__product',
    });

    $('nav.siteNav__main>div>a.submenu__recipes').addClass('is-activepage');

    this.searchVisible = false;

    this.name = 'product';
    this.name = this.name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    this.regex = new RegExp('[\\?&]' + this.name + '=([^&#]*)');
    this.results = this.regex.exec(location.search);

    $('#id_product').prepend('<option value="EggBakes">' + recipesSelectEggbakes + '</option>');
    $('#id_product').prepend('<option value="ShellEggs">' + recipesSelectShelleggs + '</option>');
    $('#id_product').prepend('<option value="">' + recipesSelectAll + '</option>');

    if (this.results === null) {
      $('#id_product').val('');
    } else {
      this.selected = decodeURIComponent(this.results[1].replace(/\+/g, ' '));
      $('#id_product').val(this.selected);
    }

    $('.form__filters').submit( () => {
      const cat1 = $('#filter1').val();
      const cat2 = $('#filter2').val();
      const searchString = $('#search_string').val();
      ga('send', 'event', 'search', `category1: ${cat1}, category2: ${cat2}, searchString: ${searchString}`);
    });

    $('#filters__showsearch').click( () => {
      if ( this.searchVisible ) {
        this.searchVisible = false;
        $('#filters__showsearch').removeClass('is-visible');
        $('#filters__textsearch').removeClass('is-visible');
        $('#filters__textsearch').attr('aria-hidden', 'true');
        $('#search_string').val('');
        $('#search_string').blur();
      } else {
        this.searchVisible = true;
        $('#filters__showsearch').addClass('is-visible');
        $('#filters__textsearch').addClass('is-visible');
        $('#filters__textsearch').attr('aria-hidden', 'false');
        $('#search_string').focus();
      }
    });
    this.transitionIn();
  }

  transitionIn() {
    // reveal the home hero text
    $('.recipes__hero .cmpnt__hero__copy__cntr').addClass('do-intro');

    setTimeout( () => {
      $('.recipes__hero .cmpnt__hero__copy__cntr').removeClass('do-intro start-intro');
    }, 2300);
  }
}



// WEBPACK FOOTER //
// ./js/controllers/pages/RecipesController.js